import type { ComponentType, ReactNode } from 'react';
import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';

interface IProps {
  breadcrumbs: IBreadcrumbItem[];
  // Each app supplies its own link (basic uses next/link, logged-in the market-aware Link).
  LinkComponent: ComponentType<{ href: string; className?: string; children: ReactNode }>;
}

/**
 * Breadcrumb trail for the venue video sub-page: Bridebook > Wedding Venues > Venue > Video.
 * Shared so the crawlable and logged-in pages render the same nav; each page owns its own item
 * list so the same data can also feed the breadcrumb structured data.
 */
export const SupplierVideoBreadcrumbs = ({ breadcrumbs, LinkComponent }: IProps) => (
  <nav aria-label="Breadcrumb" className="mb-3">
    <ol className="flex flex-row flex-wrap gap-1.5">
      {breadcrumbs.map((item, index) => (
        <li key={item.id} className="flex flex-row items-center gap-1.5">
          {item.path && index < breadcrumbs.length - 1 ? (
            <LinkComponent href={item.path} className="text-indigo-crush hover:underline">
              {item.name}
            </LinkComponent>
          ) : (
            <span>{item.name}</span>
          )}
          {index < breadcrumbs.length - 1 && <span aria-hidden>›</span>}
        </li>
      ))}
    </ol>
  </nav>
);
